import Vue from "vue";
import VueHead from "vue-head";
import "@/plugins/axios";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import Argon from "./plugins/argon-kit";
import VueProgressBar from "vue-progressbar";
import Notifications from "vue-notification";
import AppConfig from "@/plugins/config";

Vue.config.productionTip = false;
Vue.use(AppConfig);
Vue.use(Argon);
Vue.use(Notifications);
Vue.use(VueProgressBar, {
  color: "rgb(79,214,156)",
  failedColor: "red",
  thickness: "5px",
});
Vue.use(VueHead);

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount("#app");
